var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m429.806 512h-396.593c-6.873 0-12.445-5.572-12.445-12.445v-341.561h421.483v341.561c0 6.873-5.572 12.445-12.445 12.445z",
    fill: "#fe646f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m442.255 167.845v331.707c0 6.876-5.58 12.445-12.445 12.445h-23.172c6.876 0 12.445-5.569 12.445-12.445v-331.707z",
    fill: "#fd4755"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m219.008 55.476-13.211-13.539c-10.52-10.007-21.828-19.346-34.135-27.082-12.324-7.748-26.568-14.089-41.302-14.789-7.284-.346-14.605.698-21.305 3.681-27.651 12.31-43.357 47.601-40.828 76.796.134 1.545 1.709 21.341 2.133 21.341h148.648s0-46.391 0-46.408z",
    fill: "#fea613"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m244.011 55.476 13.211-13.539c10.52-10.007 21.828-19.346 34.135-27.082 12.324-7.748 26.568-14.088 41.302-14.788 7.284-.346 14.605.698 21.305 3.681 27.651 12.31 43.357 47.601 40.828 76.796-.134 1.545-1.709 21.341-2.133 21.341-.197 0-148.648 0-148.648 0s0-46.392 0-46.409z",
    fill: "#fea613"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m394.787 80.541c-.124 1.545-1.701 21.344-2.126 21.344h-18.678c.539-5.725 1.099-12.674 1.172-13.565 2.53-29.195-13.182-64.487-40.831-76.797-6.7-2.976-14.022-4.024-21.302-3.682-4.387.207-8.732.923-12.995 2.022 10.143-5.341 21.24-9.251 32.627-9.801 7.291-.342 14.613.705 21.312 3.682 27.65 12.31 43.351 47.603 40.821 76.797z",
    fill: "#fe9901"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m445.912 167.848h-428.805c-6.873 0-12.445-5.572-12.445-12.445v-44.184c0-6.873 5.572-12.445 12.445-12.445h428.806c6.873 0 12.445 5.572 12.445 12.445v44.184c-.001 6.873-5.572 12.445-12.446 12.445z",
    fill: "#fb2b3a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m285.603 101.884h-108.187v-3.801c0-29.875 24.218-54.094 54.094-54.094 29.875 0 54.093 24.218 54.093 54.094z",
    fill: "#fec165"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m285.601 98.079v3.806h-19.674v-2.842c0-14.934-6.057-28.458-15.847-38.238-8.172-8.183-18.969-13.762-31.02-15.37 3.993-.944 8.162-1.441 12.445-1.441 14.934 0 28.458 6.057 38.248 15.836 9.791 9.791 15.848 23.315 15.848 38.249z",
    fill: "#fdb441"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m166.235 98.773h130.55v69.075h-130.55z",
    fill: "#e1d3ce"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m273.889 98.773h22.896v69.075h-22.896z",
    fill: "#cdbfba"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m182.401 167.848h98.217v344.152h-98.217z",
    fill: "#f3eae6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m256.604 167.848h24.015v344.152h-24.015z",
    fill: "#e1d3ce"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m442.482 339.358h-43.479v109.83c0 4.418 4.427 7.465 8.554 5.887l32.674-12.493c1.45-.554 3.053-.554 4.502 0l32.674 12.493c4.127 1.578 8.554-1.469 8.554-5.887v-109.83z",
    fill: "#8ac9fe"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m485.961 339.36v109.832c0 4.412-4.425 7.463-8.56 5.887l-13.539-5.181c.429-.832.668-1.777.668-2.811v-107.727z",
    fill: "#60b7ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 442.482,
    cy: 300.069,
    fill: "#fec165",
    r: 64.857
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m448.263 265.693 6.911 14.004c.453.919 1.33 1.556 2.344 1.703l15.454 2.246c5.287.768 7.398 7.266 3.573 10.995l-11.182 10.9c-.734.715-1.069 1.746-.895 2.756l2.64 15.391c.903 5.266-4.624 9.282-9.353 6.795l-13.822-7.267c-.907-.477-1.99-.477-2.897 0l-13.822 7.267c-4.729 2.486-10.256-1.529-9.353-6.795l2.64-15.391c.173-1.01-.162-2.04-.895-2.756l-11.182-10.9c-3.826-3.729-1.715-10.227 3.573-10.995l15.454-2.246c1.014-.147 1.891-.784 2.344-1.703l6.911-14.004c2.36-4.792 9.192-4.792 11.557 0z",
    fill: "#fe9901"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m465.363 305.541c-.74.718-1.066 1.74-.892 2.751l2.632 15.399c.903 5.264-4.622 9.277-9.353 6.786l-13.822-7.265c-.903-.478-1.99-.478-2.893 0l-13.822 7.265c-4.731 2.49-10.255-1.522-9.353-6.786l.598-3.513c.315-.098.631-.239.946-.402l6.099-3.21c3.063-1.612 6.128-3.259 9.378-4.472 2.656-.991 5.499-1.38 8.319-1.486 3.046-.115 7.547 1.993 9.433-1.51.58-1.078.399-2.584.605-3.755.957-5.443 4.075-10.287 8.079-14.115 2.511-2.393 4.934-4.875 7.417-7.296.261-.261.5-.522.696-.805l3.545.522c5.285.761 7.395 7.265 3.567 10.995z",
    fill: "#fb8801"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.c6f7b4ca.svg";
export { ForwardRef as ReactComponent };